import { get } from "api/Base.api";
import { IAgency } from "api/interfaces/app.interface";
import { IPagination } from 'api/interfaces/common.interface';

// 캐스팅 로그 인터페이스
export interface ICastingLog {
    id: number;
    castingDate: string;
    appAgency: IAgency
}

// 캐스팅 로그 목록 조회 응답 인터페이스
export interface ICastingLogListResponse {
    castingLogList: ICastingLog[];
    pagination: IPagination;
}

/**
 * 캐스팅 로그 목록 조회
 * @param page 페이지 번호 (기본값: 1)
 * @param limit 페이지당 항목 수 (옵션)
 * @returns 캐스팅 로그 목록과 페이지네이션 정보
 */
export const getCastingLogList = async (page: number = 1, limit?: number): Promise<ICastingLogListResponse> => {
    const params: any = { page };
    if (limit !== undefined) {
        params.limit = limit;
    }
    const response = await get(`/student/v2/casting-log`, params);
    return response;
};

